import React from "react";
const VerifyCodeError = ({ codeError }) => (
  <div className="invalid-feedback d-inline-block">{codeError.message}</div>
);

export default VerifyCodeError;
